import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from 'react';
import { publicApi } from '../utils/api';

const MaintenanceContext = createContext({ enabled: false, message: '', eta: null, refresh: () => {} });

/**
 * Polls /api/maintenance/status every 30s. Frontend components consume the
 * context to render a full-page takeover for non-admin users when enabled.
 */
export function MaintenanceProvider({ children }) {
  const [state, setState] = useState({ enabled: false, message: '', eta: null });

  const refresh = useCallback(async () => {
    try {
      const { data } = await publicApi.get('/api/maintenance/status');
      setState({
        enabled: !!data?.enabled,
        message: data?.message || '',
        eta: data?.eta || null,
      });
    } catch {/* ignore network blips */}
  }, []);

  useEffect(() => {
    refresh();
    const id = setInterval(refresh, 30_000);
    return () => clearInterval(id);
  }, [refresh]);

  // Memoize so polling-driven setState doesn't fan re-renders out to every
  // consumer when the actual data hasn't changed.
  const value = useMemo(() => ({ ...state, refresh }), [state, refresh]);

  return (
    <MaintenanceContext.Provider value={value}>
      {children}
    </MaintenanceContext.Provider>
  );
}

export function useMaintenance() {
  return useContext(MaintenanceContext);
}
